import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2025/Inv/";

export const invitaciones2025 = [
    {
        'numInvitacion' : 'SIPDUS-GEH-/FASPH-ITP-1/2025',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. SIPDUS-GEH-/FASPH-ITP-1/2025',
                'vigenciaProc' : 'Vigencia: 18 de diciembre de 2025 (único día)',
                'descripcionProc' : 'Mejoramiento del Instituto de Formación Profesional; ubicada en la localidad de San José Palma Gorda, municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }ITP1/ITP1.rar`,
                'resultadosProc' : [
                    // {
                    //     'resultado' : 'Oficio Invitación',
                    //     'urlResultado' : `${ ligabase }ITP1/ITP1.rar.pdf`,
                    // },
                    {
                        'resultado' : 'Aclaraciones',
                        'urlResultado' : `${ ligabase }ITP1/APITP1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlResultado' : `${ ligabase }ITP1/JAITP1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlResultado' : `${ ligabase }ITP1/FAITP1.pdf`,
                    }
                ]
            }
        ]
    }
]